module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Saturation-1644895f7e53b6605742c02c0ad2c03c.svg";